module.exports = __webpack_public_path__ + "distribution/img/success.a85f0da7.png";